import CookieBanner from './components/global/CookieBanner';
import NavListener from './components/global/NavListener';
import { ToastComponent } from './components/global/Toast';
import { Routes } from './routes';
import { TranslationProvider } from './translation';

const App = () => {
  return (
    <TranslationProvider>
      {/* <GoogleAnalyticsTracker /> */}
      <Routes />
      <ToastComponent />
      <NavListener />
      <CookieBanner />
    </TranslationProvider>
  );
};

export default App;
